function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 9.979c-.917 0-1.667-.292-2.25-.875s-.875-1.333-.875-2.25.292-1.667.875-2.25 1.333-.875 2.25-.875 1.667.292 2.25.875.875 1.333.875 2.25-.292 1.667-.875 2.25-1.333.875-2.25.875zm-6.667 6.688v-1.959c0-.528.132-.979.396-1.354.264-.375.604-.66 1.02-.854.931-.417 1.824-.73 2.678-.938A10.824 10.824 0 0110 11.25c.861 0 1.715.107 2.562.323a17.75 17.75 0 012.667.927c.43.194.778.479 1.042.854s.396.826.396 1.354v1.958H3.333zm1.25-1.25h10.834v-.709c0-.222-.066-.434-.198-.635a1.256 1.256 0 00-.49-.448c-.889-.43-1.701-.726-2.437-.886-.736-.16-1.5-.24-2.292-.24-.792 0-1.563.08-2.313.24-.75.16-1.562.455-2.437.886a1.184 1.184 0 00-.48.448 1.186 1.186 0 00-.187.635v.708zM10 8.729c.542 0 .99-.177 1.344-.531.354-.354.53-.802.53-1.344s-.176-.99-.53-1.344c-.354-.354-.802-.531-1.344-.531s-.99.177-1.344.531c-.354.354-.531.802-.531 1.344s.177.99.531 1.344c.354.354.802.531 1.344.531z"
});

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgProfile;